export const extractApiErrorMessage = (e: unknown, fallback: string): string =>
  e &&
  typeof e === 'object' &&
  'response' in e &&
  e.response &&
  typeof e.response === 'object' &&
  'data' in e.response &&
  e.response.data &&
  typeof e.response.data === 'object' &&
  'message' in e.response.data &&
  typeof e.response.data.message === 'string'
    ? e.response.data.message
    : fallback;
